import { render, staticRenderFns } from "./smartIdDataCreate.vue?vue&type=template&id=3feb7564&"
import script from "./smartIdDataCreate.vue?vue&type=script&lang=js&"
export * from "./smartIdDataCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports